import { render, staticRenderFns } from "./DataReportNav.vue?vue&type=template&id=67fb1894&scoped=true&"
import script from "./DataReportNav.vue?vue&type=script&lang=js&"
export * from "./DataReportNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fb1894",
  null
  
)

export default component.exports